module.exports = __webpack_public_path__ + "media/npc_dota_hero_enchantress.90baea79.webm";